export default "__VITE_ASSET__CMbNH7nW__"